<ng-template #ibanField>
    <div class="iban-field" [hidden]="!showIban">
        <div class="control has-icons-right has-dynamic-placeholder">
            <input
                [ngClass]="
                    (iban?.hasError('invalidFormat') || iban?.hasError('invalidIban')) && iban?.touched
                        ? 'is-danger'
                        : '' || !iban?.valid || !iban?.value
                          ? ''
                          : 'is-success'
                "
                type="text"
                class="input form-control input-iban"
                placeholder="Nouvel IBAN"
                name="ibanControl"
                iban
                [(ngModel)]="ibanValue"
                #iban="ngModel"
            />
            <label>Nouvel IBAN</label>
            <span class="icon icon-valid-iban">
                <i class="tri-check-circle"></i>
            </span>
            <span class="icon icon-invalid-iban">
                <i class="tri-exclamation-circle"></i>
            </span>
        </div>
        @if (iban?.hasError('invalidIban') && iban?.touched) {
            <p class="help is-danger">Cet IBAN n'est pas reconnu.</p>
        }
        @if (iban?.hasError('invalidFormat') && iban?.touched) {
            <p class="help is-danger">Le format de votre IBAN n'est pas valide. Ex: {{ iban.getError('message') }}</p>
        }
    </div>
</ng-template>
<div class="modal-title">
    <p class="title is-spaced is-size-3 main-title has-text-left">Reprise mobile</p>
</div>
@if (montantEstimeReprise >= 10) {
    <div class="has-text-left">
        <p class="subtitle has-text-tertiary is-size-6">
            Finalisez la reprise de votre {{ selectedPhone.nom }}
            <span class="text paragraph is-3 has-text-weight-normal">(estimation valide jusqu’à 23h59 ce soir).</span>
        </p>
        <div class="block-prices is-flex-desktop">
            <div
                class="columns is-mobile is-vcentered is-marginless recovery-column column"
                [ngClass]="{ 'recovery-only': !bonus }"
            >
                <div class="column is-2-mobile is-1-tablet is-hidden-desktop"></div>
                <div class="column is-6-mobile is-8-tablet is-12-desktop wrapper-label">
                    <span class="text paragraph is-level-2 has-text-weight-normal label-column">
                        Valeur estimée
                        <br class="is-hidden-mobile is-hidden-tablet-only" />
                        de votre téléphone
                    </span>
                </div>
                <div class="column is-4-mobile is-12-desktop has-text-right has-text-left-desktop">
                    <div class="price is-size-5 is-size-1-desktop">
                        <span class="main">{{ montantEstimeReprise | withoutTaxPipe: isWithoutTax }}</span>
                        <span class="price-details">
                            <span class="cents">€{{ isWithoutTax ? '&nbsp;HT' : '' }}</span>
                        </span>
                    </div>
                </div>
            </div>
            <!-- Avec bonus -->
            @if (bonus) {
                <div class="is-hidden-mobile is-hidden-tablet-only icon-operation">
                    <span class="icon is-small"><i class="tri-plus-circle"></i></span>
                </div>
                <div class="columns is-mobile is-vcentered is-marginless recovery-column column">
                    <div class="column is-2-mobile is-1-tablet is-hidden-desktop">
                        <span class="icon is-small"><i class="tri-plus-circle"></i></span>
                    </div>
                    <div class="column is-6-mobile is-8-tablet is-12-desktop wrapper-label">
                        <span class="text paragraph is-level-2 has-text-weight-normal label-column">Bonus reprise</span>
                    </div>
                    <div class="column is-4-mobile is-12-desktop has-text-right has-text-left-desktop">
                        <div class="price is-size-5 is-size-1-desktop">
                            <span class="main">{{ bonus | withoutTaxPipe: isWithoutTax }}</span>
                            <span class="price-details">
                                <span class="cents">€{{ isWithoutTax ? '&nbsp;HT' : '' }}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="is-hidden-mobile is-hidden-tablet-only icon-operation">
                    <span class="icon is-small icon-equal"><i class="tri-pause"></i></span>
                </div>
                <div class="columns is-mobile is-vcentered block-total is-marginless recovery-column column">
                    <div class="column is-2-mobile is-1-tablet is-hidden-desktop">
                        <span class="icon is-small icon-equal"><i class="tri-pause"></i></span>
                    </div>
                    <div class="column is-10-mobile is-11-tablet column is-12-desktop">
                        <div class="columns is-mobile column-total">
                            <div class="column is-6-mobile is-12-desktop wrapper-label-total">
                                <span class="text paragraph is-level-2 has-text-weight-bold label-total">Total</span>
                            </div>
                            <div class="column is-6-mobile is-12-desktop has-text-right has-text-left-desktop">
                                <div class="price is-size-5 is-size-1-desktop">
                                    <span class="main">{{ montantTotal | withoutTaxPipe: isWithoutTax }}</span>
                                    <span class="price-details">
                                        <span class="cents">€{{ isWithoutTax ? '&nbsp;HT' : '' }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
        <hr class="is-divider" />
        @if (isRenewal) {
            <div class="question-item">
                <div class="columns is-fullwidth">
                    <div class="column is-8 column-question has-text-left">
                        <p class="title is-level-3">
                            Souhaitez-vous utiliser l'IBAN de votre compte client ({{ ibanOrigin }}) pour la reprise
                            mobile ?
                        </p>
                        <p class="text is-level-1 is-marginless">
                            Le paiement de votre ancien mobile est réalisé sous 48h par virement bancaire après contrôle
                            en atelier par notre partenaire&nbsp;&thinsp;
                            <img class="logo-recommerce" src="assets/svg/logo-recommerce.svg" alt="recommerce" />
                            <br />
                            <br />
                            Vous pouvez utiliser l'IBAN de votre compte client ou en utiliser un nouveau.
                        </p>
                        <div class="is-hidden-mobile">
                            <ng-container *ngTemplateOutlet="ibanField"></ng-container>
                        </div>
                    </div>
                    <div class="column is-4 is-narrow">
                        <div class="buttons is-block buttons-with-icon">
                            <trg-options
                                class="pqd-inline-options"
                                [options]="['Oui', 'Non']"
                                (onSelectOption)="useNewIban($event)"
                                [checkedValue]="showIban ? 'Non' : 'Oui'"
                            />
                        </div>
                        <div class="is-hidden-tablet">
                            <ng-container *ngTemplateOutlet="ibanField"></ng-container>
                        </div>
                    </div>
                </div>
                <div class="is-divider"></div>
            </div>
        }

        <div>
            <h3 class="title is-level-3">Utilisez l'enveloppe préaffranchie, on garantit votre envoi !</h3>
            <p class="text is-level-1 is-marginless">
                Vous recevrez une enveloppe pré-affranchie à votre adresse de facturation. &nbsp;&thinsp;
                <img class="logo-recommerce" src="assets/svg/logo-recommerce.svg" alt="recommerce" />
                garantit le transport de votre téléphone et prend en charge les coûts d'affranchissement.
            </p>
        </div>
        <div class="is-divider"></div>
        <div class="field is-flex is-justified-end-desktop recovery-legals">
            <input
                class="is-checkradio has-background-color is-info"
                id="checkCondition"
                type="checkbox"
                [checked]="checkCondition"
                (change)="updateCondition()"
            />
            <label class="is-marginless text is-level-2 paragraph has-text-weight-normal" for="checkCondition">
                <span>
                    J’accepte les&nbsp;
                    <a
                        class="link"
                        href="https://assets.recommerce.com/buyback-webgen-app/bouyguestelecom/fr/CGA.Bouygues-Recommerce.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Conditions Générales de Reprise
                    </a>
                </span>
            </label>
        </div>
        <div class="is-flex listing-actions">
            <span class="icon-and-text text is-level-2">
                <span class="icon is-small">
                    <i class="tri-arrow-left"></i>
                </span>
                <a class="has-text-weight-bold has-text-tertiary" (click)="previous()">Retour</a>
            </span>
            <trg-button primary [disabled]="!canShowButton()" (click)="close()">
                Confirmer
                <span class="hide-on-xs">&nbsp;votre reprise</span>
            </trg-button>
        </div>
    </div>
} @else {
    @if (!isLoading) {
        <div class="has-text-left inner-modal-content">
            <div class="row">
                <div class="notification is-small has-body">
                    <div class="icon">
                        <i class="tri-infos-circle"></i>
                    </div>
                    <div class="body">
                        <h5 class="text paragraph is-1 has-text-weight-bold">
                            Malheureusement, nous ne pouvons pas reprendre votre mobile en ligne car sa valeur estimée
                            est inférieure à {{ 10 | withoutTaxPipe: isWithoutTax }}€{{ isWithoutTax ? ' HT' : '' }}.
                        </h5>
                    </div>
                </div>
                <p class="text is-level-2">Cependant, nous pouvons le recycler gratuitement en boutique.</p>
                <p class="text is-level-2">
                    Vous pouvez essayer de
                    <a (click)="goToSearch()" class="link">faire estimer un autre mobile</a>
                    @if (bonus) {
                        <span>&nbsp;pour bénéficier du bonus reprise</span>
                    }
                    ou finaliser votre achat.
                </p>
                <div class="is-flex listing-actions">
                    <span class="icon-and-text">
                        <span class="icon is-small">
                            <i class="tri-arrow-left"></i>
                        </span>
                        <a class="has-text-weight-bold has-text-tertiary" (click)="goToSearch()">Retour</a>
                    </span>
                    <trg-button class="finalize-purchase" primary (click)="close(true)">
                        Finaliser votre achat
                    </trg-button>
                </div>
            </div>
        </div>
    }
}
